import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useCallback, useEffect, useState } from "react";
import { ProseMirror } from "@progress/kendo-react-editor";
import {
  GetHtmlFromLearningObjectiveReferenceComponent,
  GetLearningObjectiveReferenceComponentFromHTML,
  LearningObjectiveReferenceComponent,
} from "./learningObjectiveReferenceComponentTool";
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs";

const { DOMParser: DOMParserObj, DOMSerializer: DOMSerializerObj } = ProseMirror;

export const LearningObjectiveReferenceComponentDialog = (props: any) => {
  const [isNew, setIsNew] = useState(false);
  const { nodeAndPos, editorSchema } = props;
  const [allowSubmit, setAllowSubmit] = useState<boolean>(false);
  const [item, setItem] = useState<LearningObjectiveReferenceComponent | undefined>(undefined);

  useEffect(() => {
    const serializer = DOMSerializerObj.fromSchema(editorSchema);
    const htmlDom = serializer!.serializeNode(nodeAndPos.node);
    let s = new XMLSerializer();
    let htmlContent = s.serializeToString(htmlDom);

    let learningObjectiveComponent = GetLearningObjectiveReferenceComponentFromHTML(htmlContent);
    let tagIsNew = learningObjectiveComponent.data === undefined || learningObjectiveComponent.data === "";

    setItem(learningObjectiveComponent);
    setIsNew(tagIsNew);
    setAllowSubmit(true);
  }, [nodeAndPos, editorSchema]);

  const deleteClick = () => {
    props.onSubmit({ htmlContent: "", nodeAndPos });
  };

  const handleSubmit = useCallback(async () => {
    const domParser = new DOMParser();
    // Create a new DOM node from the HTML string
    const domNode = domParser.parseFromString(await GetHtmlFromLearningObjectiveReferenceComponent(item!), "text/html");
    // Create a new `DOMParser` instance with the schema
    const parser = DOMParserObj.fromSchema(editorSchema);
    // Parse the DOM node and create a ProseMirror node from it
    const newNode = parser.parse(domNode);
    props.onSubmit({ newNode, nodeAndPos });
  }, [item, editorSchema, nodeAndPos]);

  const handleChange = (event: any) => {
    const a = item?.data ? item.data.split("|") : [];
    if (event.checked) {
      a.push(event.value);
    } else {
      a.splice(a.indexOf(event.value), 1);
    }
    setItem({ ...item, data: a.join("|") });
  };

  return (
    <Dialog
      title="Learning Objective Reference"
      onClose={props.onCancel}
      width="80vw"
      height="80vh"
      style={{ overflowY: "scroll" }}
    >
      {!item?.data && <p>Inga lärandemål valda</p>}

      {props.learningObjectivesInLearningObject.map((lo: any) => (
        <div key={lo.identifier}>
          <Checkbox
            value={item?.data?.includes(lo.identifier)}
            label={props.learningObjectives.find((item: any) => item.identifier === lo.identifier)?.name}
            onChange={(event: CheckboxChangeEvent) => handleChange({ value: lo.identifier, checked: event.value })}
          />
        </div>
      ))}

      <DialogActionsBar>
        <div style={{ textAlign: "right" }}>
          {!isNew && (
            <button
              type="button"
              className="k-button k-button-md k-button-rectangle k-button-solid k-button-solid-danger k-rounded-md"
              onClick={deleteClick}
            >
              Ta bort
            </button>
          )}

          <button
            type={"button"}
            disabled={!allowSubmit}
            className="k-button k-button-md k-button-rectangle k-primary k-button-solid k-button-solid-primary k-rounded-md"
            onClick={handleSubmit}
          >
            {isNew ? "Lägg till" : "Uppdatera"}
          </button>
          <button
            type="button"
            className="k-button k-button-md k-button-rectangle k-button-solid k-rounded-md k-button-solid-base"
            onClick={props.onCancel}
          >
            Avbryt
          </button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
